<div appPanel (closePanelEmitter)="close()"></div>

<div class="modal_content w-auto">
  <button class="mat-modal-closer" mat-dialog-close>
    <svg-icon
      src="assets/images/svg-icons/icon-times-light.svg"
      [svgStyle]="{ 'width.px': '18' }"
    ></svg-icon>
  </button>

  <div class="modal-inside -video">
    <ng-container *ngIf="podcast">
      <div
        [innerHTML]="podcast.content | safe : 'html'"
        *ngIf="podcast.content"
        class="block-iframe h-[150px] aspect-auto"
      ></div>
      <div class="mt-4 flex space-x-6 items-start p-4 sm:p-0">
        <div class="rounded-full overflow-hidden w-[40px] h-[40px] object-cover shrink-0">
          <img [src]="podcast.course.specialties[0].icon" />
        </div>
        <div class="grow">
          <div class="sm:flex justify-between sm:space-x-8 space-y-2 sm:space-y-0">
            <div class="font-bold text-16">
              {{ podcast.title }}
            </div>
            <div class="flex space-x-4 text-12 items-center">
              <div class="flex space-x-4 bg-theme-gray-seventeen py-2 px-4 rounded-sm shrink-0">
                <svg-icon
                  src="assets/images/svg-icons/icon-eye.svg"
                  [svgStyle]="{ 'width.px': '17' }"
                  class="text-site-theme-accent"
                ></svg-icon>
                <span class="text-theme-black">{{ podcast.totalViews }}</span>
              </div>
              <div class="font-semibold capitalize whitespace-nowrap">
                {{ podcast.createdAt | amDateFormat : 'MMM YYYY' }}
              </div>
            </div>
          </div>
          <div class="mt-6 bg-site-theme-main-five rounded p-4 flex flex-col items-start">
            <div class="font-bold mt-2">
              <a
                [routerLink]="
                  languageService.linkToCoursesEnabled
                    ? ['/app/courses/course', podcast.course.id]
                    : null
                "
                (click)="close()"
                class="block"
              >
                {{ podcast.course.displayName }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!podcast">
      <div class="flex justify-center items-center h-[100px]">
        <app-loader-dots></app-loader-dots>
      </div>
    </ng-container>
  </div>
</div>
